import {
    Message
} from "element-ui";
import {
    getCompanyList
} from "../../../api/suitability";
const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;

export const fiterCompany = {
    data() {
        return {
            filteredCompanyList: [],
            companyList: []
        }
    },
    methods: {
        fiterCompany(query) {
            const self = this;
            if (query !== "") {
                self.filteredCompanyList = self.companyList.filter(item => {
                    return (
                        ( item.companyNamePhonetic !=null && item.companyName !=null ) 
                        &&
                        ( item.companyNamePhonetic
                              .toLowerCase()
                              .indexOf(query.toLowerCase()) > -1 ||
                          item.companyName.indexOf(query) > -1 )
                    );
                });
            } else {
                self.filteredCompanyList = self.companyList;
            }
        },
        handleCompany() {
            const self = this;
            getCompanyList()
                .then(response => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message: "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                self.companyList = self.filteredCompanyList =
                                    result.data.companyList;
                            }
                        }
                    }
                })
                .catch(err => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000
                    });
                    Message.close = function() {};
                })
                .finally(r => {
                    self.loading = false;
                });
        },
    }
}
